import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import { cn } from "../lib/utils.js";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    data-lumika-checkbox=""
    className={cn(
      // The tap target is a centered pseudo-element, not the box itself: the
      // old `@media (pointer: coarse) { min-height: 2.75rem }` inflated the
      // bordered square into a 44px slab, and keyed off the pointer rather
      // than the breakpoint — a narrow desktop window kept a 20px target
      // while a touch laptop at 1440px got 44px. Same trick as Switch.
      "relative inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-control border border-input bg-background text-primary-foreground shadow-xs outline-none transition-colors duration-fast ease-operational",
      "before:absolute before:left-1/2 before:top-1/2 before:h-11 before:w-11 before:-translate-x-1/2 before:-translate-y-1/2 before:content-[''] sm:before:h-9 sm:before:w-9",
      "hover:border-primary/60 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
      "disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      {props.checked === "indeterminate" ? (
        <Minus aria-hidden className="h-3.5 w-3.5" />
      ) : (
        <Check aria-hidden className="h-3.5 w-3.5" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
